export type { ProductReviewModalProps } from './ProductReviewsModal';
export { messages, ProductReviewModal } from './ProductReviewsModal';
